import { createStyle } from '@gluestack-style/react';

export const SectionList = createStyle({});
